var SMARTIFYAPPS = SMARTIFYAPPS || {};
SMARTIFYAPPS.rv = SMARTIFYAPPS.rv || {};

!function(e){var n=!1;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var o=window.Cookies,t=window.Cookies=e();t.noConflict=function(){return window.Cookies=o,t}}}(function(){function e(){for(var e=0,n={};e<arguments.length;e++){var o=arguments[e];for(var t in o)n[t]=o[t]}return n}function n(o){function t(n,r,i){var c;if("undefined"!=typeof document){if(arguments.length>1){if(i=e({path:"/"},t.defaults,i),"number"==typeof i.expires){var a=new Date;a.setMilliseconds(a.getMilliseconds()+864e5*i.expires),i.expires=a}try{c=JSON.stringify(r),/^[\{\[]/.test(c)&&(r=c)}catch(e){}return r=o.write?o.write(r,n):encodeURIComponent(String(r)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),n=encodeURIComponent(String(n)),n=n.replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent),n=n.replace(/[\(\)]/g,escape),document.cookie=[n,"=",r,i.expires?"; expires="+i.expires.toUTCString():"",i.path?"; path="+i.path:"",i.domain?"; domain="+i.domain:"",i.secure?"; secure":""].join("")}n||(c={});for(var p=document.cookie?document.cookie.split("; "):[],s=/(%[0-9A-Z]{2})+/g,d=0;d<p.length;d++){var f=p[d].split("="),u=f.slice(1).join("=");'"'===u.charAt(0)&&(u=u.slice(1,-1));try{var l=f[0].replace(s,decodeURIComponent);if(u=o.read?o.read(u,l):o(u,l)||u.replace(s,decodeURIComponent),this.json)try{u=JSON.parse(u)}catch(e){}if(n===l){c=u;break}n||(c[l]=u)}catch(e){}}return c}}return t.set=t,t.get=function(e){return t.call(t,e)},t.getJSON=function(){return t.apply({json:!0},[].slice.call(arguments))},t.defaults={},t.remove=function(n,o){t(n,"",e(o,{expires:-1}))},t.withConverter=n,t}return n(function(){})});if (typeof Cookies !== 'undefined') {
    SMARTIFYAPPS.rv.Cookies = Cookies.noConflict();
}

SMARTIFYAPPS.rv.Cookie = SMARTIFYAPPS.rv.Cookie || {
    name: 'scm_reviews_importer_app',
    count: 'scm_reviews_importer_count',
    setInstalled: function() {
        SMARTIFYAPPS.rv.Cookies.set(this.count, 0);
        SMARTIFYAPPS.rv.Cookies.set(this.name, "installed");
    },
    isInstalled: function() {
        var count = SMARTIFYAPPS.rv.Cookies.get(this.count);
        if (! count) count = 0;
        count++;
        SMARTIFYAPPS.rv.Cookies.set(this.count, count);

                    return SMARTIFYAPPS.rv.Cookies.get(this.name) === "installed" && count < 2;
            }
};

SMARTIFYAPPS.rv.performanceNow = SMARTIFYAPPS.rv.performanceNow || function() {
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        return Math.round(performance.now()) + ' ms ';
    } else {
        return '';
    }
};

    var scripts = document.head.getElementsByTagName('script');
    for (var i = 0; i < scripts.length; ++i) {
        if(scripts[i].innerText.indexOf('asyncLoad') >= 0 &&
            (scripts[i].innerText.indexOf("reviews.smartifyapps.com\\/storage\\/scripts") >= 0 ||
             scripts[i].innerText.indexOf("d1bu6z2uxfnay3.cloudfront.net\\/storage\\/scripts") >= 0
            )
        ) {
            console.log('already has scripttag, load RV');
            SMARTIFYAPPS.rv.installed = true;
            SMARTIFYAPPS.rv.Cookie.setInstalled();
        }
    }
    if (! SMARTIFYAPPS.rv.Cookie.isInstalled()) {
        SMARTIFYAPPS.rv.installed = false;
        console.log(SMARTIFYAPPS.rv.performanceNow() + 'preload skip');
    } else {
        SMARTIFYAPPS.rv.installed = true;
    }

if (SMARTIFYAPPS.rv.loadingApp !== true && SMARTIFYAPPS.rv.installed === true) {
    SMARTIFYAPPS.rv.loadingApp = true;

    SMARTIFYAPPS.rv.loadScript = SMARTIFYAPPS.rv.loadScript || function(url, callback){
        var script = document.createElement("script");
        script.type = "text/javascript";
        if (script.readyState){  // IE
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {  // Others
            script.onreadystatechange = callback;
            script.onload = callback;
        }

        script.src = url;
        var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(script, x);
    };

    SMARTIFYAPPS.rv.loadStyle = SMARTIFYAPPS.rv.loadStyle || function(url){
        var head = document.getElementsByTagName("head")[0];
        var extension = '.css';
        var link = document.createElement("link");
        link.href = url;
        link.type = "text/css";
        link.rel = "stylesheet";
        head.appendChild(link);
    };
                    SMARTIFYAPPS.rv.scmReviewsRate = SMARTIFYAPPS.rv.scmReviewsRate || (function() {
  function loadCss(filename) {
    var cssNode = document.createElement('link');
    cssNode.setAttribute('rel', 'stylesheet');
    cssNode.setAttribute('type', 'text/css');
    cssNode.setAttribute('href', filename);
    document.getElementsByTagName('head')[0].appendChild(cssNode);
  };


  function getInfoShop() {
    var infoShopElem = document.getElementById('scm-reviews-shopSetting');
    if (!infoShopElem)
        return '';
    var infoShop = infoShopElem.getAttribute('data-shop');
    return infoShop;
  };
let infoShopParam= getInfoShop();
let settingApp = (function(infoShopParam) {
    if(infoShopParam === 'null' || infoShopParam === ''){
        infoShopParam= '{}';
    }
    let infoShopJson= JSON.parse(infoShopParam);
    let checkSetting = function(strText) {
        if (typeof (strText) == "undefined" || strText == 'undefined') {
            return false;
        }
        return true;
    };
    let defaultSetting= {
        starColor: checkSetting(infoShopJson.starColor) ? infoShopJson.starColor : "#fa4f56",
        starStyle: checkSetting(infoShopJson.starStyle) ? infoShopJson.starStyle : 'star',
        width: checkSetting(infoShopJson.width) ? infoShopJson.width : "1200px",
        reviewBg:   checkSetting(infoShopJson.reviewBg) ? infoShopJson.reviewBg : "#ffffff",
        starRating_color: checkSetting(infoShopJson.starRating_color) ? infoShopJson.starRating_color : null,
        starRating_hideIfNoReviews : checkSetting(infoShopJson.starRating_hideIfNoReviews) ? infoShopJson.starRating_hideIfNoReviews : false,
        starRating_showText : checkSetting(infoShopJson.starRating_showText) ? infoShopJson.starRating_showText : false,
        patternNoRating:   checkSetting(infoShopJson.starRating_EmptyReview) ? infoShopJson.starRating_EmptyReview : "",
        patternRating:   checkSetting(infoShopJson.starRating_SingularReview) ? infoShopJson.starRating_SingularReview : "({{ n }} review)",
        patternRatings:   checkSetting(infoShopJson.starRating_PluralReview) ? infoShopJson.starRating_PluralReview : "({{ n }} reviews)"
    };
    let settingCustom = {
        hasBg : defaultSetting.reviewBg !== '#ffffff' ? true : false
    };
    let getSettingFromShop = function () {
        return Object.assign(defaultSetting, settingCustom);
    };
    return getSettingFromShop();
})(infoShopParam);
SMARTIFYAPPS.rv.htmlRating= function(blockStar,rate){
    if(typeof SMARTIFYAPPSCustomRating!== 'undefined'){
        return SMARTIFYAPPSCustomRating(blockStar,rate);
    }
    let ratingHtml= rate.total > 0 ? `${blockStar}(${rate.total})` : `${blockStar}`;
    if(settingApp.starRating_showText){
        let pattern= settingApp.patternRatings;
        switch(rate.total) {
            case 0:
                pattern= settingApp.patternNoRating;
                break;
            case 1:
                pattern= settingApp.patternRating;
                break;
            default:
                pattern= settingApp.patternRatings;
        }
        ratingHtml= pattern.replace(`{{ average_rating }}`, rate.average);
        ratingHtml= pattern.replace(`{{average_rating}}`, rate.average);
        ratingHtml = ratingHtml.replace(`{{n}}`, rate.total);
        ratingHtml = ratingHtml.replace(`{{ n }}`, rate.total);
        ratingHtml= blockStar + ratingHtml;
    }
    if(rate.total == 0){
    return `<div class="lai-content-star lai-none-rating"><div class="lai-wrap-block-star">${ratingHtml}</div></div>`;
    }
    return `<div class="lai-content-star"><div class="lai-wrap-block-star">${ratingHtml}</div></div>`;
};
let iconStar= {
    'star' : {
        'rating': `<svg class="Path_1_" viewBox="0 11.796 15.128 14.431">
            <path id="Path_1_" d="M 15.10665130615234 17.27590179443359 C 15.05453205108643 17.11542510986328 14.91586685180664 16.99847793579102 14.74892520904541 16.97425079345703 L 10.05909633636475 16.29273986816406 L 7.961684226989746 12.04304504394531 C 7.88704776763916 11.89176177978516 7.732958793640137 11.79600048065186 7.564273357391357 11.79600048065186 C 7.395556449890137 11.79600048065186 7.241498470306396 11.89176177978516 7.16683292388916 12.04304504394531 L 5.069331645965576 16.29273986816406 L 0.3795907497406006 16.97425079345703 C 0.2126783281564713 16.99847793579102 0.07395394891500473 17.11542510986328 0.02183260396122932 17.2758674621582 C -0.03031831048429012 17.43634033203125 0.01317525468766689 17.61246871948242 0.133993998169899 17.73021697998047 L 3.527437686920166 21.03815460205078 L 2.726470708847046 25.70907592773438 C 2.697927951812744 25.87537002563477 2.766300439834595 26.04337692260742 2.902779340744019 26.14256286621094 C 2.979986429214478 26.19864654541016 3.07143497467041 26.22718811035156 3.163326740264893 26.22718811035156 C 3.233885526657104 26.22718811035156 3.304681062698364 26.21037673950195 3.369507789611816 26.17627716064453 L 7.564243793487549 23.97093200683594 L 11.75880241394043 26.17624664306641 C 11.90816497802734 26.25475311279297 12.08908271789551 26.24169540405273 12.22556018829346 26.14253616333008 C 12.36203765869141 26.04337692260742 12.43044185638428 25.87530899047852 12.40192794799805 25.70901489257813 L 11.60069465637207 21.03815841674805 L 14.99452018737793 17.73019027709961 C 15.11531257629395 17.61246871948242 15.15883350372314 17.43634033203125 15.10665130615234 17.27590179443359 Z">
            </path>*
        </svg>
        `,
        'none': `<svg class="svg_none" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9259 7.72832L8.446 7.65245L8.67845 7.18104L11.6065 1.24292C11.6066 1.24272 11.6067 1.24252 11.6068 1.24231C11.643 1.16964 11.6987 1.10846 11.7677 1.06566C11.8369 1.02274 11.9166 1 11.9981 1C12.0795 1 12.1593 1.02274 12.2284 1.06566C12.2975 1.10848 12.3532 1.16969 12.3893 1.24241C12.3894 1.24258 12.3895 1.24275 12.3896 1.24292L15.3188 7.18022L15.5512 7.65147L16.0712 7.72732L22.6244 8.6832C22.6245 8.68322 22.6246 8.68323 22.6247 8.68325C22.7051 8.69509 22.7805 8.72913 22.8425 8.78152C22.9046 8.83399 22.9508 8.90278 22.9759 8.98011C23.0009 9.05745 23.0039 9.14026 22.9844 9.21919C22.9649 9.29811 22.9237 9.37001 22.8655 9.42677L18.1237 14.0476L17.747 14.4147L17.836 14.9331L18.9565 21.4574C18.9566 21.4577 18.9566 21.458 18.9567 21.4582C18.97 21.538 18.9609 21.6199 18.9303 21.6949C18.8996 21.77 18.8486 21.8351 18.7829 21.8828C18.7173 21.9305 18.6396 21.959 18.5586 21.9649C18.478 21.9708 18.3973 21.9542 18.3255 21.9169C18.3253 21.9168 18.325 21.9167 18.3247 21.9165L12.4639 18.8356L11.9985 18.591L11.5331 18.8357L5.67117 21.9182C5.67105 21.9182 5.67094 21.9183 5.67082 21.9183C5.59909 21.9559 5.51831 21.9726 5.43757 21.9668C5.35669 21.9609 5.27907 21.9325 5.21346 21.8848C5.14786 21.8372 5.09689 21.7721 5.0663 21.697C5.03578 21.6221 5.02676 21.5401 5.04025 21.4604C5.04028 21.4602 5.04031 21.46 5.04034 21.4598L6.16113 14.9341L6.25016 14.4157L5.87347 14.0486L1.13164 9.42777C1.07342 9.37101 1.03224 9.29911 1.01273 9.22019C0.993229 9.14126 0.99618 9.05845 1.02125 8.98111C1.04633 8.90378 1.09252 8.83499 1.15463 8.78252C1.21665 8.73013 1.29207 8.69609 1.37238 8.68425C1.37249 8.68423 1.3726 8.68421 1.37271 8.6842L7.9259 7.72832Z"  stroke-width="2"/>
        </svg>
        `
    },
    'heart' : {
        'rating': `<svg  viewBox="0 0 24 20"  xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.56923 0C3.44903 0 0 3.08744 0 7.02394C0 10.7936 2.14173 13.714 4.48902 15.7827C6.84059 17.8551 9.50649 19.1726 10.8194 19.7512C11.5723 20.0829 12.4277 20.0829 13.1806 19.7512C14.4935 19.1727 17.1594 17.8552 19.511 15.7828C21.8583 13.7141 24 10.7937 24 7.0241C24 3.08764 20.551 0 16.4308 0C14.7204 0 13.192 0.721551 12 1.57464C10.808 0.721552 9.2796 0 7.56923 0Z" />
        </svg>
        `,
        'none': `<svg class="svg_none" viewBox="0 0 24 20"  xmlns="http://www.w3.org/2000/svg">
            <path d="M11.418 2.38783L12 2.80437L12.582 2.38783C13.6751 1.60549 15.0021 1 16.4308 1C20.0813 1 23 3.71901 23 7.0241C23 10.3857 21.093 13.0556 18.8498 15.0325C16.6086 17.0077 14.0482 18.2761 12.7774 18.8361C12.2814 19.0546 11.7186 19.0546 11.2226 18.8361C9.95178 18.2761 7.39142 17.0076 5.15021 15.0324C2.90699 13.0555 1 10.3855 1 7.02394C1 3.71885 3.91873 1 7.56923 1C8.99794 1 10.3249 1.60549 11.418 2.38783Z" stroke-width="2"/>
        </svg>
        `
    },
    'like' : {
        'rating': `<svg viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
            <path d="M20.4 5.03144H15.6V2.37584C15.602 1.37551 14.9683 0.481559 14.0161 0.14141C13.0639 -0.198739 11.9981 0.0880958 11.352 0.858353L8.04001 4.79433C7.499 5.43257 7.20174 6.23807 7.20001 7.07056V24H20.4C22.3882 24 24 22.4077 24 20.4434V8.58804C24 6.62378 22.3882 5.03144 20.4 5.03144Z"/>
            <path d="M0 8.58803V22.8145C0 23.4692 0.537258 24 1.2 24H4.8V7.4025H1.2C0.537258 7.4025 0 7.93328 0 8.58803Z" />
        </svg>

        `,
        'none': `<svg class="svg_none" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4 5.03144H15.6V2.37584C15.602 1.37551 14.9683 0.481559 14.0161 0.14141C13.0639 -0.198739 11.998 0.0880958 11.352 0.858353L8.04 4.79433C7.49898 5.43257 7.20173 6.23807 7.2 7.07056V7.40251H1.2C0.537258 7.40251 0 7.93329 0 8.58804V22.8145C0 23.4692 0.537258 24 1.2 24H20.4C22.3882 24 24 22.4077 24 20.4434V8.58804C24 6.62378 22.3882 5.03144 20.4 5.03144ZM2.39999 9.77357H7.19999V21.6289H2.39999V9.77357ZM20.4 21.6289C21.0627 21.6289 21.6 21.0982 21.6 20.4434V8.58804C21.6 7.93329 21.0627 7.40251 20.4 7.40251H14.4C13.7372 7.40251 13.2 6.87173 13.2 6.21697V2.37584L9.87598 6.31182C9.69708 6.52511 9.59943 6.79356 9.59998 7.07056V21.6289H20.4Z" />
        </svg>
        `
    },
    'smile' : {
        'rating': `<svg  viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
            <path d="M12 0C5.38776 0 0 5.38776 0 12C0 18.6122 5.38776 24 12 24C18.6122 24 24 18.6122 24 12C24 5.38776 18.6122 0 12 0ZM8.32653 7.10204C8.93878 7.10204 9.55102 7.71429 9.55102 8.32653C9.55102 8.93878 8.93878 9.55102 8.32653 9.55102C7.71429 9.55102 7.10204 8.93878 7.10204 8.32653C7.10204 7.71429 7.71429 7.10204 8.32653 7.10204ZM16.2857 16.4082C14.9388 17.3878 13.8367 17.8776 12 17.8776C10.1633 17.8776 9.18367 17.5102 7.71429 16.4082C7.34694 16.1633 7.22449 15.551 7.59184 15.1837C7.95918 14.8163 8.44898 14.6939 8.81633 15.0612C9.91837 15.7959 10.6531 16.0408 11.8776 16.0408C13.102 16.0408 13.9592 15.7959 14.9388 15.0612C15.3061 14.8163 15.9184 14.8163 16.1633 15.1837C16.4082 15.551 16.6531 16.0408 16.2857 16.4082ZM15.6735 9.55102C15.0612 9.55102 14.449 8.93878 14.449 8.32653C14.449 7.71429 15.0612 7.10204 15.6735 7.10204C16.2857 7.10204 16.898 7.71429 16.898 8.32653C16.898 8.93878 16.2857 9.55102 15.6735 9.55102Z" />
        </svg>

        `,
        'none': `<svg class="svg_none" viewBox="0 0 24 24"  xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.84615C6.39219 1.84615 1.84615 6.39219 1.84615 12C1.84615 17.6078 6.39219 22.1538 12 22.1538C17.6078 22.1538 22.1538 17.6078 22.1538 12C22.1538 6.39219 17.6078 1.84615 12 1.84615ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"/>
        </svg>
        `
    }
};

function addStyleOnHead() {
    let widthContainer = settingApp.width ? settingApp.width : '1200px';
    let color_star= settingApp.starRating_color ? settingApp.starRating_color : settingApp.starColor;
    let styleConfig = `
        .scm-reviews-rate svg{
            width: 17.128px;
            height: 17.431px;
            stroke: none;
            fill: ${color_star} !important;
        }
        .scm-container{
            background: ${settingApp.reviewBg};
        }
        .scm-reviews-importer{
            max-width: ${widthContainer}
        }
        .lai-group-star{
            position: relative;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            margin-right: 2px;
            height: 18px;
            font-size: 0;
            margin-bottom: 0 !important;
        }
        .lai-star-rating {
            position: absolute;
            overflow: hidden;
        }
        .lai-content-star{
            display: inline-block;
            font-size: 0px;
        }
        .lai-wrap-block-star{
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 16px;
            line-height: 19px;
        }
        .scm-reviews-rate svg.svg_none {
            fill: none !important;
            stroke: ${color_star} !important;
        }
        .scm-reviews-rate span{
            font-size: 16px;
            line-height: 18px;
        }
        .scm-reviews-rate{
            text-decoration: none;
        }
    `;
    if(settingApp.starRating_hideIfNoReviews){
        styleConfig= styleConfig + `
            .lai-content-star.lai-none-rating{
                display: none;
            }
        `;
    }
    var linkElement = this.document.createElement('link');
    linkElement.setAttribute('rel', 'stylesheet');
    linkElement.setAttribute('type', 'text/css');
    linkElement.setAttribute('href', 'data:text/css;charset=UTF-8,' + encodeURIComponent(styleConfig));
    document.querySelector('head').appendChild(linkElement);
  }

  function getElement() {
    var x = document.getElementsByClassName('scm-reviews-rate');
    return [].slice.call(x);
  };

  function actionCreateReviews() {
    setTimeout(function(){
        let arrayListElement = getElement();
        arrayListElement.forEach(element => {
          let rate = {
            'average': 0,
            'total': 0
          };
        let idProduct= element.getAttribute('data-product-id');
        let checkTrueProduct= true;
        let rateVersion2 = element.getAttribute('data-rate-version2');
            if(!rateVersion2 || rateVersion2 == ''){
                if(element.childNodes[0].nodeName == 'SPAN')
                    rateVersion2= element.outerText;
            }
            if (rateVersion2 && rateVersion2 != 'null') {
                rateVersion2 = JSON.parse(rateVersion2);
                rate = {
                  'average': rateVersion2['average'],
                  'total': rateVersion2['total']
                };
            }else{
                rateVersion2 = {"rate1":0,"rate2":0,"rate3":0,"rate4":0,"rate5":0,"total":0,"average":0};
                rate = {
                    'average': 0,
                    'total': 0
                };
            }
            if(idProduct ){
                if(!rateVersion2 || !rateVersion2.hasOwnProperty('product_shopify_id')){
                    checkTrueProduct = true;
                }else {
                    checkTrueProduct= (rateVersion2.product_shopify_id && idProduct !==rateVersion2.product_shopify_id ) ? false : true;
                }
            }
            let blockStar="";
            if(!checkTrueProduct){
                rateVersion2 = {"rate1":0,"rate2":0,"rate3":0,"rate4":0,"rate5":0,"total":0,"average":0};
                rate = {
                    'average': 0,
                    'total': 0
                };
            }
            if (rate && rate.average > 0) {
                blockStar = scmReviewsRate(rate.average);
            }else{
                blockStar = scmReviewsRate(0);
            }
            blockStar = SMARTIFYAPPS.rv.htmlRating(blockStar,rateVersion2);
            element.innerHTML = blockStar;
            element.style.display= "";
        });
    },0);
  }


  function scmReviewsRate(value) {
    let blockStar = '';
    if(value != 0){
    let number = Math.floor(value);
    let decimal = value - number;
    decimal= decimal.toFixed(2)*100;
    if(number < 5){
        for (let i = 0; i <= number; i++) {
            let style="";
            if( i == number){
                style= "width: " + decimal + `%;`;
            }
            blockStar = blockStar + '<div class="lai-group-star">' + '<div class= "lai-star-rating" style= "' + style + '">' + iconStar[settingApp.starStyle].rating + '</div>' + '<div class= "lai-star-rating-none">'+ iconStar[settingApp.starStyle].none + '</div>' + '</div>';
        }
        for (let i = (number + 1); i < 5; i++) {
            blockStar = blockStar + '<div class="lai-group-star">' + iconStar[settingApp.starStyle].none + '</div>';
        }
    }
    else{
        for (let i = 0; i < 5; i++) {
            blockStar = blockStar + '<div class="lai-group-star">' + iconStar[settingApp.starStyle].rating + '</div>';
        }
    }

    }else{
        for (let i = 0; i < 5; i++) {
            blockStar = blockStar + '<div class="lai-group-star">' + iconStar[settingApp.starStyle].none + '</div>';
        }
    }
    return blockStar;
  };

  function parseJson(value) {
    if (value) {
      let valueDecode64 = atob(value);
      return JSON.parse(valueDecode64);
    } else {
      return value;
    }
  };

  function getUrlParameter(sParam) {
    var sPageURL = location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');
      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };
    function dispatchEventBeforeScrollToWidgetReviews(){
        const eventClickStar = document.createEvent('Event');
        eventClickStar.initEvent('beforeScrollToReviewWidget', true, true);
        document.dispatchEvent(eventClickStar);
    };
  function scrollWigetReview() {
    let widgetEl = document.querySelector('.scm-container.custom');
    let widget = widgetEl ? widgetEl : document.querySelector('.scm-container');
    if(widget){
        widget.scrollIntoView();
    }
  };

  function onWindowLoad() {
    document.querySelector('body').setAttribute('data-review-app', 'true');
    actionCreateReviews();
    if (getUrlParameter('review') || getUrlParameter('reviews') || getUrlParameter('review_email')) {
      setTimeout(function() {
        scrollWigetReview();
      }, 0);

    }
  };

  function constructor() {
    addStyleOnHead();
  };

  function init() {
    constructor();
    actionCreateReviews();
  };

  return {
    init,
    actionCreateReviews,
    onWindowLoad,
    getUrlParameter,
    scrollWigetReview,
    dispatchEventBeforeScrollToWidgetReviews
  };
})();

            SMARTIFYAPPS.rv.startReviewsImporter = SMARTIFYAPPS.rv.startReviewsImporter || function() {
        console.log(SMARTIFYAPPS.rv.performanceNow() + 'smart aliexpress reviews app starting...');
                    function startReviewImporter() {
  document.querySelectorAll('a[href="#scm-reviews-importer"]').forEach(item => {
    item.addEventListener('click', event => {
        SMARTIFYAPPS.rv.scmReviewsRate.dispatchEventBeforeScrollToWidgetReviews();
        setTimeout(function(){
            SMARTIFYAPPS.rv.scmReviewsRate.scrollWigetReview();
        }, 10);
    })
  });
  document.querySelectorAll('.link-star-scm-reviews').forEach(item => {
    item.addEventListener('click', event => {
        SMARTIFYAPPS.rv.scmReviewsRate.dispatchEventBeforeScrollToWidgetReviews();
        setTimeout(function(){
            SMARTIFYAPPS.rv.scmReviewsRate.scrollWigetReview();
        }, 10);
    })
  });
  document.addEventListener("click", function(e){
    let elementClicked= e.target.className;
    if(elementClicked=="scm-popup-before"){
        closePopup();
    }
  });
  const remove = function (e) {
    e.stopPropagation();
    closePopup();
  };
  window.onload = function(){

  };

      function closePopup() {
            var scmpopupContainer = document.getElementById("scm-review-importer-popup");
            let iframeDocument = document.querySelector('#scm-review-importer-popup-iframe').contentWindow.document;
            iframeDocument.open('text/html', 'replace');
            iframeDocument.write('');
            scmpopupContainer.classList.remove('show-popup');
            document.getElementById('scm-review-importer-popup').style.display= "none";
            var scmpopupContainerWrite = document.getElementById("scm-review-importer-popup-write-review");
            scmpopupContainerWrite.classList.remove('show-popup');
            document.getElementById('scm-review-importer-popup-write-review').style.display= "none";
      };
    function createIframePopup(htmlPopup){
        var scmpopupContainer = document.getElementById("scm-review-importer-popup");
        scmpopupContainer.classList.add('show-popup');
        var iframeDocument = document.querySelector('#scm-review-importer-popup-iframe').contentWindow.document;
        document.getElementById('scm-review-importer-popup').style.display= "block";
        iframeDocument.open('text/html', 'replace');
        if((typeof htmlPopup == "undefined" || htmlPopup == null)){
        }else{
            iframeDocument.write(htmlPopup);
        }
        iframeDocument.close();
    };
    function createPopup(data) {
        let htmlPopup= createPopupHtml(data);
        createIframePopup(htmlPopup);
    };
    function createIframePopupWriteReviews(htmlPopup){
        var scmpopupContainer = document.getElementById("scm-review-importer-popup-write-review");
        if(scmpopupContainer.classList.contains('loaded')){
            document.getElementById('scm-review-importer-popup-write-review').style.display= "block";
            scmpopupContainer.classList.add('show-popup');
        }else{
            scmpopupContainer.classList.add('show-popup');
            scmpopupContainer.classList.add('loaded');
            var iframeDocument = document.querySelector('#scm-review-importer-popup-write-review-iframe').contentWindow.document;
            document.getElementById('scm-review-importer-popup-write-review').style.display= "block";
            iframeDocument.open('text/html', 'replace');
            iframeDocument.write(htmlPopup);
            iframeDocument.close();
        }
    };

    function createPopupWriteReview(data){
        let htmlPopup= writeReviews(data);
        createIframePopupWriteReviews(htmlPopup);
    };

  function changeHeightIframe(height) {
    const elFrame = document.querySelector(".custom #scm-reviews-importer-iframe");
    const frame = elFrame ? elFrame : document.querySelector(".scm-reviews-importer-iframe");
    frame.height = height + "px";
    frame.parentNode.style.height = height + 'px';
  };

  function receiveMessage(event) {
    if (event.data.type === 'createPopup') {
        createPopup(event.data);
    }
    else if (event.data.type === 'createPopupWriteReviews') {
        createPopupWriteReview(event.data);
    }
    else if (event.data === 'removePopup') {
        closePopup();
    } else if (event.data.type === 'changeHeight') {
        changeHeightIframe(event.data.height);
    }
  };

    window.addEventListener('message', receiveMessage, false);
    const elRoot = document.querySelector('.custom #scm-reviews-importer');
    const root= elRoot ? elRoot : document.querySelector('.scm-reviews-importer');
      if(root){
            let iframeEl = document.querySelector('.custom #scm-reviews-importer-iframe');
            let iframeRoot= iframeEl ? iframeEl : document.querySelector('.scm-reviews-importer-iframe');
            let iframeDocument=  iframeRoot.contentWindow.document;
            iframeDocument.open('text/html', 'replace');
            if((typeof htmlIframe == "undefined" || htmlIframe == null)){
            }else{
                iframeDocument.write(htmlIframe);
            }
          iframeDocument.close();
      }
}

startReviewImporter();
                        SMARTIFYAPPS.rv.scmReviewsRate.init();
                window.onload = (event) => {
                    SMARTIFYAPPS.rv.scmReviewsRate.onWindowLoad();
                };
                    let rootElFrame= document.querySelector(".scm-container.custom");
            let rootFrame= rootElFrame ? rootElFrame : document.querySelector(".scm-container");
            if(rootFrame){
                rootFrame.style.display= "";
            }
            }; // end of SMARTIFYAPPS.rv.startReviewsImporters

    console.log(SMARTIFYAPPS.rv.performanceNow() + 'smart aliexpress reviews script loaded');
    SMARTIFYAPPS.rv.init=  SMARTIFYAPPS.rv.init || (function(calback) {
        calback();
    });
    if(typeof SMARTIFYAPPSCustomInit!== 'undefined'){
        SMARTIFYAPPS.rv.init= SMARTIFYAPPSCustomInit.init;
    }
    SMARTIFYAPPS.rv.init(SMARTIFYAPPS.rv.startReviewsImporter);
} else {
    console.log(SMARTIFYAPPS.rv.performanceNow() + 'skip');
}
